// One gtag.js for every Google tag on the page (GA4 and Google Ads share it).
let scriptAdded = false;

export function ensureGtag(firstId) {
  window.dataLayer = window.dataLayer || [];
  if (!window.gtag) {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
  }
  if (scriptAdded) return;
  scriptAdded = true;
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(firstId)}`;
  document.head.appendChild(script);
}
